import FileSave from 'file-saver';

import useFetchData from 'hooks/useFetchData';

export const useDownloadDataFile = () => {
  const { getData, isDataLoading } = useFetchData();

  const downloadFile = async (url: string, defaultFileName: string) => {
    await getData(
      url,
      () => {},
      (blob, headers) => {
        const filenameHeader = headers.get('X-Filename');
        const finalFilename = filenameHeader || defaultFileName;
        FileSave.saveAs(blob, finalFilename);
      }
    );
  };

  return { downloadFile, isDataLoading };
};
